/** @module SiteAdmin/Document/RefDocWizToolbar */
define([
	"dojo/_base/declare",
	"dojo/text!./RefDocWizardToolbar.html",
	"csi/view/Toolbar"
], function(declare,template, Toolbar) {

	return declare(Toolbar, {
		//Custom toolbar template with styled secondary toolbar on top of primary
		templateString: template
	});
});